module.exports = __webpack_public_path__ + "img/brands-github.92e779a8.svg";